import { cloneDeep } from "lodash";
import { initialState } from "../initialState";
import { numberActions as actions } from "../actions";
import { createReducer, methodSwitcher } from "./utilities";

const { number } = initialState;

const clearCurrent = (state) => ({ ...state, current: {} });

const setNumberList = (state, { data }) => {
  const newState = cloneDeep(state);
  newState.list = data;
  return newState;
};

const setCurrentNumber = (state, { data }) => {
  const newState = cloneDeep(state);
  newState.current = data;
  return newState;
};

const actionNumber = (state, { data, id, method }) => {
  const newState = cloneDeep(state);
  methodSwitcher(newState, data, id, method);
  return newState;
};

export const numberReducer = createReducer(number, {
  [actions.CLEAR_CURRENT]: clearCurrent,
  [actions.LIST]: setNumberList,
  [actions.CURRENT]: setCurrentNumber,
  [actions.CUD]: actionNumber,
});
